import { useEffect } from 'react';
import { ServicePackage } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useServicePackages() {
  const api = useAxios(
    (axios, signal) =>
      axios.request<ServicePackage[]>({
        signal,
        url: `${PRISMA_CONFIG.oldBackendUrl}/shipper-premium-service-subscriptions/packages`,
        method: 'GET',
        timeout: 5000,
      }),
    { neededOnPageLoad: true, cacheKey: 'ServicePackages' }
  );

  useEffect(() => {
    api.execute();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return api;
}

export type ServicePackagesRequest = ReturnType<typeof useServicePackages>;
